(function($) {$(document).ready(function() {

	$('.col-accord__title').on('click', event => {
		if (window.innerWidth >= 768) return;

		const $this = $(event.target);
		
		$this
			.parent()
			.toggleClass('open')
			.find('.col-accord__desc')
			.slideToggle();
	});

	$('.col-accord__item.open-on-load')
		.addClass('open')
		.find('.col-accord__desc')
		.show();

});;jQueryBridget("flickity", Flickity, $);})(window.NEW_jquery);